import { render, staticRenderFns } from "./WhatsappForm.vue?vue&type=template&id=6f7f55b4"
import script from "./WhatsappForm.vue?vue&type=script&lang=js"
export * from "./WhatsappForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports